import { render } from "./PlanedTrainingViewer.vue?vue&type=template&id=337afc62"
import script from "./PlanedTrainingViewer.vue?vue&type=script&lang=js"
export * from "./PlanedTrainingViewer.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__